/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kullanim_S4_I1Inputs */

const tr_kullanim_s4_i1 = /** @type {(inputs: Kullanim_S4_I1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kullanıcı 18 yaşından büyük, fiil ehliyetine sahip olmalıdır.`)
};

const en_kullanim_s4_i1 = /** @type {(inputs: Kullanim_S4_I1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The User must be over 18 years of age and have legal capacity.`)
};

const de_kullanim_s4_i1 = /** @type {(inputs: Kullanim_S4_I1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Nutzer muss über 18 Jahre alt und geschäftsfähig sein.`)
};

const ru_kullanim_s4_i1 = /** @type {(inputs: Kullanim_S4_I1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пользователь должен быть старше 18 лет и обладать дееспособностью.`)
};

/**
* | output |
* | --- |
* | "The User must be over 18 years of age and have legal capacity." |
*
* @param {Kullanim_S4_I1Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kullanim_s4_i1 = /** @type {((inputs?: Kullanim_S4_I1Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kullanim_S4_I1Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kullanim_s4_i1(inputs)
	if (locale === "de") return de_kullanim_s4_i1(inputs)
	if (locale === "ru") return ru_kullanim_s4_i1(inputs)
	return tr_kullanim_s4_i1(inputs)
});